import {NeoButton, NeoTextBox} from "@/components/forms";
import {NeoHeader} from "@/components/shared";
import {yupResolver} from "@hookform/resolvers/yup";
import {useState} from "react";
import {useForm} from "react-hook-form";
import {AiOutlineLoading} from "react-icons/ai";
import * as yup from "yup";

export const CreateRoutePlan = function () {
  const [loading, setLoading] = useState(false);
  const validationSchema = yup.object().shape({
    planName: yup
      .string()
      .required("Please enter your name")
      .matches(/^[a-zA-Z .]*$/, "Please enter the valid name")
  });

  const {
    reset,
    resetField,
    register,
    handleSubmit,
    formState: {isSubmitting, isValid, errors},
    control,
    setValue,
    setError,
    clearErrors
  } = useForm<any>({
    defaultValues: {},
    mode: "onChange",
    resolver: yupResolver(validationSchema)
  });
  const onSubmit = (data: any) => {
    //console.log(data);
  };
  return (
    // <div className="flex min-h-[calc(100vh-63px)] w-full flex-col p-5">
    <>
      <div className="mb-5 flex-row">
        <NeoHeader message="Create Plan"></NeoHeader>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="py-2">
          <NeoTextBox
            label={
              <span>
                Plan Name <span className="text-red-500">*</span>
              </span>
            }
            id="planName"
            type="text"
            placeholder="Please enter your plan name"
            color={errors.planName ? "danger" : "default"}
            isInvalid={errors.planName ? true : false}
            errorMessage={errors.planName && `${errors.planName.message}`}
            {...register("planName")}
          />
        </div>
        <div className="flex items-center justify-end p-1">
          <NeoButton
            className="mx-1 bg-[#FFC727] text-[#000000]"
            type="submit"
            disabled={isSubmitting}
            isLoading={loading}
            spinner={
              <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
            }
            color="black"
          >
            Add
          </NeoButton>
        </div>
      </form>
    </>
    // </div>
  );
};
